import logger from "../logger/logger-init"
import { contentServiceClientConfig } from "@/lib/content-service/interfaces/IContentServiceClientConfig"
import { ClientFetchService } from "@/lib/http/ClientFetchService"
import { ContentServiceClient } from "@/lib/content-service/ContentServiceClient"
import { ContentServiceProductService } from "@/lib/content-service/services/ContentServiceProductService"

const clientFetchService = new ClientFetchService(contentServiceClientConfig, logger)

const contentServiceProductService = new ContentServiceProductService(
    clientFetchService,
    logger
)

const contentServiceClientOnlyClient = new ContentServiceClient(
    contentServiceProductService
)

export default contentServiceClientOnlyClient
